const API_BASE = process.env.REACT_APP_API_BASE || 'http://localhost:5000';

export const fetchOptions = async () => {
  try {
    const response = await fetch(`${API_BASE}/options`);
    if (!response.ok) throw new Error('Failed to fetch options');
    return await response.json();
  } catch (err) {
    console.error('Error fetching options:', err);
    return null;
  }
};

const generateStartup = async (selections) => {
  try {
    console.log('Sending request to generate startup:', selections);
    const response = await fetch(`${API_BASE}/generate`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(selections)
    });
    
    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.error || 'Startup generation failed');
    }

    const data = await response.json();
    console.log('Received startup data:', data);
    console.log('Startup idea structure:', data.startup_idea);
    console.log('Landing page content:', data.startup_idea?.landing_page_content);
    console.log('Sections:', data.startup_idea?.landing_page_content?.sections);
    console.log('CTA:', data.startup_idea?.landing_page_content?.cta);

    // Transform the data structure to match what the frontend expects
    const transformedData = {
      name: data.startup_idea?.name || data.name || 'Startup Name',
      colorTheme: data.startup_idea?.color_theme || data.colorTheme || {
        background: '#20232a',
        card: '#2d2f36',
        text: '#ffffff'
      },
      landing: data.startup_idea?.landing_page_content || data.landing || {
        title: 'Startup Title',
        subtitle: 'A new innovative startup',
        sections: [
          { title: 'Section 1', description: 'Description 1' },
          { title: 'Section 2', description: 'Description 2' },
          { title: 'Section 3', description: 'Description 3' }
        ],
        cta: 'Learn More'
      },
      _timestamp: Date.now()
    };
    
    // Ensure sections array exists and has at least 3 sections
    if (!transformedData.landing.sections || transformedData.landing.sections.length < 3) {
      console.log('Adding missing sections to landing data');
      transformedData.landing.sections = [
        { title: 'Section 1', description: 'Description 1' },
        { title: 'Section 2', description: 'Description 2' },
        { title: 'Section 3', description: 'Description 3' }
      ];
    }
    
    // Ensure CTA exists
    if (!transformedData.landing.cta) {
      console.log('Adding missing CTA to landing data');
      transformedData.landing.cta = 'Learn More';
    }
    
    console.log('Transformed data structure:', transformedData);
    console.log('Transformed landing:', transformedData.landing);
    console.log('Transformed sections:', transformedData.landing?.sections);
    console.log('Transformed CTA:', transformedData.landing?.cta);

    // Generate logo
    let logo = 'https://via.placeholder.com/150x150.png?text=No+Logo';
    try {
      const logoPrompt = `${transformedData.name} - A themed logo for a startup in the ${selections.ramoDeAtividade.join(', ')} sector with ${selections.caracteristicas.join(', ')} characteristics. Visual identity colors:${transformedData.colorTheme.background} ${transformedData.colorTheme.card} ${transformedData.colorTheme.text}`;
      
      console.log('Generating logo with prompt:', logoPrompt);
      const logoResponse = await fetch(`${API_BASE}/generate-logo`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ prompt: logoPrompt })
      });
      if (logoResponse.ok) {
        const logoData = await logoResponse.json();
        logo = logoData.imageUrl;
        console.log('Logo generated:', logo);
      } else {
        console.error('Failed to generate logo:', await logoResponse.json());
      }
    } catch (error) {
      console.error('Error generating logo:', error);
    }

    const result = { ...transformedData, logo };
    console.log('Final startup data with logo:', result);
    return result;

  } catch (err) {
    console.error('Error generating startup:', err);
    throw err;
  }
};

export default generateStartup;
